export default __webpack_public_path__ + "static/media/Skup Pula (6).ac4c8230.JPG";